/* eslint-disable @angular-eslint/component-selector */
import { Component, Input, OnInit } from '@angular/core';
import { symbols } from './keys';
import { Shortcut } from './ng-keyboard-shortcuts.interfaces';
import { identity } from './utils';

/**
 * @ignore
 */
@Component({
    selector: 'ng-keyboard-shortcuts-help-item',
    templateUrl: './ng-keyboard-shortcuts-help-item.component.html',
    styleUrls: ['./ng-keyboard-shortcuts-help-item.component.css'],
    standalone: false,
})
export class KeyboardShortcutsHelpItemComponent implements OnInit {
    public parsedKeys: string[][];

    @Input() public index: number;

    @Input()
    public set shortcut(shortcut: Partial<Shortcut>) {
        const key = Array.isArray(shortcut.key) ? shortcut.key : [shortcut.key];
        this.parsedKeys = key.map((k: string) =>
            k
                .split(' ')
                .filter(identity)
                .filter((subKey) => subKey !== '+')
                .map((subKey: string) => {
                    const symbolKey = subKey as keyof typeof symbols;
                    if (symbols[symbolKey]) {
                        return symbols[symbolKey];
                    }
                    return subKey;
                })
        );
        this._shortcut = shortcut;
    }
    public get shortcut() {
        return this._shortcut;
    }

    private _shortcut: Partial<Shortcut>;

    constructor() {}

    public ngOnInit() {}
}
